module.exports = __webpack_public_path__ + "static/media/epark-vial.ad4c2d37.svg";